export default __webpack_public_path__ + "img/cb876eda8d47114b1575226b62004876.svg";